export default __webpack_public_path__ + "2d4b9a1672589a91b7ea8c68438f9e27.png";